__turbopack_context__.v({
  "dateFilterField": "customizationPanel-module-scss-module__NuAAfG__dateFilterField",
  "description": "customizationPanel-module-scss-module__NuAAfG__description",
  "noResults": "customizationPanel-module-scss-module__NuAAfG__noResults",
  "noResultsQuery": "customizationPanel-module-scss-module__NuAAfG__noResultsQuery",
  "panel": "customizationPanel-module-scss-module__NuAAfG__panel",
  "presets": "customizationPanel-module-scss-module__NuAAfG__presets",
  "presetsLabel": "customizationPanel-module-scss-module__NuAAfG__presetsLabel",
  "searchField": "customizationPanel-module-scss-module__NuAAfG__searchField",
  "searchRow": "customizationPanel-module-scss-module__NuAAfG__searchRow",
  "tabContentHidden": "customizationPanel-module-scss-module__NuAAfG__tabContentHidden",
  "tabs": "customizationPanel-module-scss-module__NuAAfG__tabs",
  "tabsWrapper": "customizationPanel-module-scss-module__NuAAfG__tabsWrapper",
  "title": "customizationPanel-module-scss-module__NuAAfG__title",
  "viewBadge": "customizationPanel-module-scss-module__NuAAfG__viewBadge",
  "viewSelect": "customizationPanel-module-scss-module__NuAAfG__viewSelect",
  "viewSelectField": "customizationPanel-module-scss-module__NuAAfG__viewSelectField",
  "viewSelectRow": "customizationPanel-module-scss-module__NuAAfG__viewSelectRow",
});
